import React from "react";

import "./CryptoList.css";
import Card from "./Card";
import CardHeader from "./CardHeader";

const CryptoList = ({ data }) => {
    return (
        <table className='crypto_table'>
            <CardHeader />
            {data.map((coin, index) => {
                return (
                    <Card
                        key={index}
                        image={coin.image}
                        name={coin.name}
                        symbol={coin.symbol}
                        price={coin.current_price}
                        volume={coin.total_volume}
                        pchange={coin.price_change_percentage_24h}
                        mcap={coin.market_cap}
                    />
                );
            })}
        </table>
    );
};

export default CryptoList;
